import { render, staticRenderFns } from "./organization.vue?vue&type=template&id=2b89a362"
import script from "./organization.vue?vue&type=script&lang=js"
export * from "./organization.vue?vue&type=script&lang=js"
import style0 from "./organization.vue?vue&type=style&index=0&id=2b89a362&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports